import { render, staticRenderFns } from "./BottomSheetFetchNotifications.vue?vue&type=template&id=565be2b3&scoped=true&"
import script from "./BottomSheetFetchNotifications.vue?vue&type=script&lang=js&"
export * from "./BottomSheetFetchNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetFetchNotifications.vue?vue&type=style&index=0&id=565be2b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565be2b3",
  null
  
)

export default component.exports